const zh_hk = {
    logo : '雄韜',
    about_us : '關於我們',
    user_cases : '成功案例',
    contact_us : '同我地傾傾',
    services : '與眾不同',
    slogan_title : '我們是您專屬的IT',
    slogan_button_text : '成功案例',
    contact_us_sec_title : "同我地傾傾",
    contact_us_sec_summary : '我們都是好的聆聽者',
    services_sec_title : '我們與眾不同',
    services_sec_fea_expert : '專業團隊',
    services_sec_fea_expert_intro : '從軟件開發到硬件生產，我們都由我們專業團隊親力親為',
    services_sec_fea_agile : '敏捷交付',
    services_sec_fea_agile_intro : '以帶給顧客最大價值為依歸，小步快跑，快速迭代交付解決方案',
    services_sec_fea_worth : '最優方案',
    services_sec_fea_worth_intro : '只選最合適的方案，不選最貴的。把顧客的利益放在第一位',
    services_sec_fea_integration : '軟硬結合',
    services_sec_fea_integration_intro : '軟硬結合是我們能夠量身訂製提供最優全面方案的根本',
    services_sec_fea_cust : '量身訂製',
    services_sec_fea_cust_intro : '了解顧客的需求，為顧客在現實目標的路上提供客制化的方案',
    services_sec_fea_full : '整體方案',
    services_sec_fea_full_intro : '方案必需是整體的。服務也不是一次性的。我們就是您專屬的IT部門',
    footer_sec_partner_title : '合作夥伴',
    footer_sec_partner_1 : '卓聯智造',
}

export default zh_hk;


// WEBPACK FOOTER //
// ./src/zh_hk.js